import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import _toConsumableArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";

var defaultFormatter = function defaultFormatter(messages, ctx) {
  var msgs = _toConsumableArray(messages);

  if (ctx.name) {
    msgs.unshift("[".concat(ctx.name, "]"));
  }

  return msgs;
};

export var Logger = /*#__PURE__*/function () {
  // logger支持的打印方法列表，有序，索引值为level级别
  // 不同方法对应的打印级别

  /**
   * 日志打印
   * @param {String} name 系统标识
   * @param {Object} options 自定义选项
   * @param {Number} options.level 打印级别，低于该级别的日志将不会被打印
   * @param {Function} options.formatter 打印格式函数，接收一个打印方法参数的数组和当前logger对象，需返回数组格式
   */
  function Logger(name) {
    var _this = this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        level = _ref.level,
        formatter = _ref.formatter;

    _classCallCheck(this, Logger);

    this.name = name;
    this.formatter = formatter || defaultFormatter;
    this.setLevel(level); // 动态初始化logger方法

    Logger.LOG_METHODS.forEach(function (logMethod) {
      _this[logMethod] = function () {
        for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
          messages[_key] = arguments[_key];
        }

        _this.invoke(logMethod, messages);
      };
    });
  }

  _createClass(Logger, [{
    key: "invoke",
    value: function invoke(type, messages) {
      if (this.level > Logger.LEVELS[type]) {
        return;
      }

      try {
        var _console;

        (_console = console)[type].apply(_console, _toConsumableArray(this.formatter(messages, this)));
      } catch (e) {
        console.error("[logger] Failed to print logger.".concat(type, " because of: "), e);
      }
    }
    /**
     * 更新打印级别，需在初始化完成后调用
     * @param {Number | Undefined} val 打印级别，默认会根据运行环境设置
     */

  }, {
    key: "setLevel",
    value: function setLevel(val) {
      if (typeof val === 'number') {
        this.level = val;
      } else {
        // 以防未编译直接在浏览器环境调用，try一下
        try {
          // 默认开发环境全部打印，生产环境打印最后两个级别
          this.level = process.env.NODE_ENV === 'production' ? Logger.LEVELS[Logger.LOG_METHODS[Logger.LOG_METHODS.length - 2]] : Logger.LEVELS[Logger.LOG_METHODS[0]];
        } catch (e) {
          this.level = Logger.LEVELS[Logger.LOG_METHODS[0]];
          console.error('[logger] Set default level to 0 because of:', e);
        }
      }
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.level;
    }
  }]);

  return Logger;
}(); // 动态初始化各方法的level

_defineProperty(Logger, "LOG_METHODS", ['trace', 'debug', 'info', 'warn', 'error']);

_defineProperty(Logger, "LEVELS", {});

Logger.LOG_METHODS.forEach(function (logMethod, index) {
  Logger.LEVELS[logMethod] = index;
});
export default new Logger('vft-common');